<template>
    <header class="o-d-header header ui ui-header">
        <div class="o-d-header__close-message">
            <svg-icon
                original
                name="icons/icon-clock"
                class="o-d-header__close-message__icon"
            />
            {{
                currentDayData.closed ? $t('ui.store-closed') : $t('ui.center-open-till', { closeTime })
            }}
            
        </div>
        <span class="o-d-header__text">
            <button
                type="button"
                class="header__button"
                :aria-label="ariaLabel"
                @click="handleClick"
            >
                <img v-if="logo" :src="logo"/>
            </button>
        </span>
    </header>
</template>

<script>
import  {
    mapState,
    mapGetters 
} from 'vuex';

import { 
    SHOW_OVERLAY,
    CHECK_SEARCH_VALUE
} from "../../../utils/constants/bus-events-constants";
import { WEB_START } from '../../../utils/constants/pages';

import {getDayNumber} from '../../../utils/helpers/dateConverter';

import { REMOVE_PATH } from "../../../shared/components/map-viewer/constants/map-commands";

export default {
    name: 'ODStoroHeader',
    props: {
        ariaLabel: {
            type: String,
            default: 'To web start'
        }
    },
    computed: {
        ...mapState({
            openingHours: state => state.map.meta.otg_opening_hours,
        }),
        ...mapGetters(['getMap', 't']),
        logo() {
            return this.t(this.getMap,'logo_light') || null;
        },
        currentDayData() {
            return this.openingHours.find(day => day.openDay == getDayNumber())
        },
        closeTime() {
            if(this.currentDayData.openPeriods[0]?.closeTime) {
                return this.currentDayData.openPeriods[0].closeTime
            } else {
                return this.$t('ui.no-close-time')
            }
             
        }
    },
    methods: {
        handleClick() {
            this.$bus.$emit(REMOVE_PATH);
            this.$bus.$emit(CHECK_SEARCH_VALUE);
            if (this.$route.name === WEB_START) return;
            this.$router.push({name: WEB_START})
        }
    }
}
</script>

<style lang="scss">
@import "o-d-storo-header";   
</style>
